// src/Pages/Landing/JoyrideSatakuntaLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideSatakuntaLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Satakunta"
      cities={[
        "Pori",
        "Rauma",
        "Harjavalta",
        "Kokemäki",
        "Ulvila",
        "Eura",
        "Huittinen"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Satakunnan alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Porin, Rauman ja lähikuntien alueet sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}